import React from "react";
import { ArrowRight, Sparkles, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

const solutions = [
  {
    title: "PDF Processing",
    desc: "AI-powered document extraction",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=600&auto=format&fit=crop",
  },
  {
    title: "WhatsApp Agent",
    desc: "AI-Powered Chat for WhatsApp",
    image:
      "https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?q=80&w=600&auto=format&fit=crop",
  },
  {
    title: "Query Engine",
    desc: "Transforming reports into Excel",
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=600&auto=format&fit=crop",
  },
  {
    title: "Workflow Automation",
    desc: "Automating emails & approvals",
    image:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=600&auto=format&fit=crop",
  },
];

const features = [
  "LLM Integration",
  "RAG Architecture",
  "Voice AI",
  "Conversational Agents",
  "Document Intelligence",
  "Self-Hosted Models",
  "NLP",
  "Computer Vision",
  "Vector Databases",
];

const AiInnovation = () => {
  return (
    <div className="w-full bg-[#f8fafc] py-24 sm:py-32 overflow-hidden border-t border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">

        {/* Main Flex Container */}
        <div className="flex flex-col lg:flex-row gap-16 items-start">

          {/* Left Column: Text & Features */}
          <div className="lg:w-1/2 flex flex-col justify-center">

            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-100/50 border border-blue-200 text-blue-600 text-sm font-semibold tracking-wide uppercase mb-8">
              <Sparkles className="w-4 h-4 text-blue-500" /> AI Innovation in Action
            </div>

            <h2 className="text-4xl md:text-5xl font-extrabold text-[#0f172a] leading-tight mb-6">
              Let's build the future of{" "}
              <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                AI together.
              </span>
            </h2>

            <p className="text-lg md:text-xl text-gray-600 leading-relaxed mb-10">
              Orryworx brings deep expertise in applied Artificial Intelligence, building production-grade AI systems
              that solve real business challenges. From intelligent document processing and conversational AI to voice
              powered assistants and retrieval-augmented generation (RAG) architectures, we deliver AI solutions that
              integrate seamlessly into enterprise workflows.
            </p>

            <div className="mb-10">
              <h3 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-5">Core Capabilities</h3>
              <div className="flex flex-wrap gap-3">
                {features.map((feature, idx) => (
                  <span
                    key={idx}
                    className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-white border border-gray-200 text-gray-700 text-sm font-medium shadow-sm"
                  >
                    <CheckCircle2 className="w-4 h-4 text-blue-500" />
                    {feature}
                  </span>
                ))}
              </div>
            </div>

            <div>
              <Link to="/contact" className="group inline-flex bg-blue-600 hover:bg-blue-700 transition-all duration-300 text-white font-semibold px-8 py-3.5 rounded-xl shadow-lg shadow-blue-500/30 items-center gap-2">
                Start a project
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>

          {/* Right Column: Solutions Grid */}
          <div className="lg:w-1/2 w-full">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {solutions.map((item, index) => (
                <div
                  key={index}
                  className="group relative overflow-hidden rounded-2xl h-[240px] shadow-md border border-gray-200/50"
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/40 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 p-5">
                    <h4 className="text-lg font-bold text-white mb-1 leading-tight">
                      {item.title}
                    </h4>
                    <p className="text-sm text-gray-300">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AiInnovation;